import { all } from 'redux-saga/effects';
import authSagas from '@iso/redux/auth/saga';
import catSaga from '@iso/redux/category/saga';
import cattreeSaga from '@iso/redux/categorytree/saga';
import grpSwitchSaga from '@iso/redux/groupSwitch/saga';
import groupsSaga from '@iso/redux/groups/saga';
import labelsSaga from '@iso/redux/labels/saga';
import categoriesSaga from '@iso/redux/categories/saga';
import productSaga from '@iso/redux/product/saga';
import logProductSaga from '@iso/redux/logProduct/saga';
import countrySaga from '@iso/redux/country/saga';
import userSaga from '@iso/redux/user/saga';
import masterSaga from '@iso/redux/master/saga';
import dataSourceSaga from '@iso/redux/dataSource/saga';
import brandManufacturerSaga from '@iso/redux/brandManufacturer/saga';
import logsSaga from "@iso/redux/logs/saga";


export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    catSaga(),
    cattreeSaga(),
    grpSwitchSaga(),
    groupsSaga(),
    labelsSaga(),
    categoriesSaga(),
    productSaga(),
    logProductSaga(),
    countrySaga(),
    userSaga(),
    masterSaga(),
    dataSourceSaga(),
    brandManufacturerSaga(),
    logsSaga(),
  ]);
}
